<template>
  <div style="background-color: #F4FFFA;">
    <b-row no-gutters v-if="screenWidth <= 600">
      <b-col>
        <institute-mobile-view :selectedInstitute="selectedInstitute" :usersList="usersList" :groupList="groupList">
        </institute-mobile-view>
      </b-col>
    </b-row>

    <div v-if="screenWidth > 600">
      <b-container fluid class="p-0">
        <div class="loading" v-if="fetchData || loadInstitutes">
          <load-data></load-data>
        </div>

        <div id="instituteTabs" v-else>
          <div v-if="academicYearWarning">
            <b-alert v-if="$root.default_academic_year[0] == '0'" class="p-1 m-0 text-center" show variant="danger">
              <span style="font-size:14px !important;"> Please select correct academic year to view data in proper
                order</span>
            </b-alert>
          </div>

          <InstituteInvite lazy @invitationClosed="inviteInstitutionUsers = false" v-if="inviteInstitutionUsers"
            ref="inviteUsers" :selectedInstitute="selectedInstitute" :instituitionAdmin=instituitionAdmin />

          <b-button variant="outline-light" size="sm" class="action-card-btn mx-1" @click="openRoleAcademicyears()"
            v-if="!studentTab && $store.state.userRole == 'Student'">
            <div class="d-flex flex-column align-items-center py-3">
              <i class="fas fa-user-cog fa-2x mb-2 text-warning"></i>
              <span class="dashboard-btn-text">Role : <small>{{ $store.state.userRole }}</small>
                <br><small v-if="acedemic_year && acedemic_year.length === 7">{{ acedemic_year }}-{{ semester }}</small>

                <small v-else>All</small></span>
            </div>
          </b-button>
          <b-collapse id="mainContent-collapse" :visible="$root.subContent.enableMainContent">
            <!-- SINGLE CARD WITH 3 ROWS -->
            <div v-if="!studentTab" class="dashboard-header">
              <!-- ===================== Admin Role ONE CARD — ALL BUTTONS INSIDE ===================== -->

              <div class="p-3 rounded shadow-sm bg-white" v-if="instituitionAdmin">
                <!-- ===== ADMIN ROW 1 ===== -->
                <div class="d-flex flex-wrap justify-content-center mb-2">
                  <b-button v-for="(btn, i) in adminRow1" :key="'r1-' + i" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click">
                    <div class="d-flex flex-column align-items-center py-2 text-center">
                      <i :class="`fas ${btn.icon} fa-2x mb-2 ${btn.color}`"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>

                <!-- ===== ADMIN ROW 2 ===== -->
                <div class="d-flex flex-wrap justify-content-center mb-2">
                  <b-button v-for="(btn, i) in adminRow2" :key="'r2-' + i" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click">
                    <div class="d-flex flex-column align-items-center py-2">
                      <i :class="`fas ${btn.icon} fa-2x mb-2 ${btn.color}`"></i>
                      <span class="dashboard-btn-text">{{ btn.text }}</span>
                    </div>
                  </b-button>
                </div>

                <!-- ===== ADMIN ROW 3 ===== -->
                <div class="d-flex flex-wrap justify-content-center gap-3">
                  <b-button v-for="(btn, i) in adminRow3" :key="'r3-' + i" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click">
                    <div class="d-flex flex-column align-items-center py-2">
                      <i :class="`fas ${btn.icon} fa-2x mb-2 ${btn.color}`"></i>
                      <span class="dashboard-btn-text">{{ btn.text }}</span>
                    </div>
                  </b-button>
                </div>
              </div>


              <!-- =====================Faculty- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="$store.state.userRole === 'Faculty'">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in facultyButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>

                      <!-- Pending badge -->
                      <span v-if="btn.extraPending"
                        style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); padding: 5px; color: #dc3545; font-weight: 700; font-size: 0.65rem; font-style: italic; white-space: nowrap; animation: pulseScale 1.5s ease-in-out infinite;">
                        <small>Pending-{{ $store.getters.getApprovalStatus.formsApprovals.counts }}</small>
                      </span>
                    </div>
                  </b-button>
                </div>
              </div>

              <!-- =====================COE- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="isCoe">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in coeButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>
              </div>

              <!-- =====================Accounts Staff- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="isAccountsStaff">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in accountsButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>
              </div>

              <!-- =====================Admission Coordinator- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="admissionCoordinator">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in admissionCoordinatorButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>
              </div>

              <!-- =====================HR- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="hrStaff">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in hrButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>
              </div>

              <!-- =====================Librarian- ONE CARD — ALL BUTTONS INSIDE ===================== -->
              <div class="p-3 rounded shadow-sm bg-white" v-else-if="isLibrarian">
                <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                  <b-button v-for="(btn, index) in librarianButtons" :key="index" variant="outline-light" size="sm"
                    class="action-card-btn mx-1" @click="btn.click()">
                    <div class="d-flex flex-column align-items-center py-3 position-relative">
                      <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                      <span class="dashboard-btn-text" v-html="btn.text"></span>
                    </div>
                  </b-button>
                </div>
              </div>

              <br>
            </div>

            <div class="dashboard-header p-3" v-else>

              <div class="d-flex flex-wrap justify-content-center gap-3 mb-0">
                <b-button v-for="(btn, index) in studentRow1" :key="index" variant="outline-light" size="sm"
                  class="action-card-btn mx-1" @click="btn.click()">
                  <div class="d-flex flex-column align-items-center py-3 position-relative">
                    <i :class="['fas', btn.icon, 'fa-2x mb-2', btn.color]"></i>
                    <span class="dashboard-btn-text" v-html="btn.text"></span>

                    <!-- Pending approval icon -->
                    <i v-if="btn.extraPending" class="fas fa-circle text-success mt-1" style="font-size: 10px;"></i>
                  </div>
                </b-button>
              </div>
            </div>



            <b-tabs id="staffListTab" v-model="tabIndex" lazy class="custom-tabs"
              v-if="!studentTab && $store.state.userRole == 'Faculty' && !instituitionAdmin && selectedInstituteRole != null">

              <!-- Attendance Tab -->
              <b-tab v-if="attendenceTab">
                <template #title>
                  <span :style="tabIndex === 0 ? 'text-decoration: underline; color: blue;' : ''">
                    Attendance
                  </span>
                </template>
                <new-attendence-marking ref="attendenceMarking"></new-attendence-marking>
              </b-tab>

              <!-- Activity Tab -->
              <b-tab v-if="!studentTab && assessmentTab">
                <template #title>
                  <span :style="tabIndex === 1 ? 'text-decoration: underline; color: blue;' : ''">
                    Activity
                  </span>
                </template>
                <Exams lazy />
              </b-tab>

              <!-- University Exam Tab -->
              <b-tab v-if="!instituitionAdmin && universityExam">
                <template #title>
                  <span :style="tabIndex === 2 ? 'text-decoration: underline; color: blue;' : ''">
                    University Exam
                  </span>
                </template>
                <UniversityExamListing :hide_title="true" lazy />
              </b-tab>

              <!-- Survey Tab -->
              <b-tab v-if="!instituitionAdmin && !studentTab && surveyTab">
                <template #title>
                  <span :style="tabIndex === 3 ? 'text-decoration: underline; color: blue;' : ''">
                    Survey
                  </span>
                </template>
                <ListingSurveys :hide_title="true" lazy />
              </b-tab>

              <!-- My Courses Tab -->
              <b-tab v-if="myCourses" @click="editCourseComponents = true">
                <template #title>
                  <span :style="tabIndex === 4 ? 'text-decoration: underline; color: blue;' : ''">
                    My Courses
                  </span>
                </template>
                <my-courses :editCourseComponents="editCourseComponents"></my-courses>
              </b-tab>

              <!-- Usersubgroup/Courses Tab -->
              <b-tab v-if="!instituitionAdmin && (mainGroupAdmin || userGroupAdmin || subgroupAdmin)" id="admin">
                <template #title>
                  <span :style="tabIndex === 5 ? 'text-decoration: underline; color: blue;' : ''">
                    {{ getCustomNames.userSubgroup.custom_name != null
                      ? getCustomNames.userSubgroup.custom_name
                      : 'Usersubgroup' }}/Courses
                  </span>
                </template>
                <Usersubgroup :hide_title="true" lazy :getCustomNames="getCustomNames" :selectedInstitute="selectedInstitute" />
              </b-tab>

              <!-- Instructor Schedule Tab -->
              <b-tab v-if="studentTab && instructorSchedule">
                <template #title>
                  <span :style="tabIndex === 6 ? 'text-decoration: underline; color: blue;' : ''">
                    Instructor Schedule
                  </span>
                </template>
                <instructor-schedule :hide_title="true"></instructor-schedule>
              </b-tab>

            </b-tabs>

          </b-collapse>
        </div>

      </b-container>
    </div>


    <b-collapse id="subContent-collapse" :visible="!$root.subContent.enableMainContent">
      <b-row class="ml-5 no-print subContentComponentCloseButton">
        <b-button size="sm"
          @click="$root.subContent.enableMainContent = true; $root.subContent.subContentComponent = '';"
          variant="danger">Close</b-button>
      </b-row>
      <ExamEvaluation v-if="$root.subContent.subContentComponent == 'ActivityEvaluation'"
        :exam_id="$root.subContent.subContentData.exam_id" lazy />
      <editCourseAttendanceFormWithReport
        v-if="$root.subContent.subContentComponent == 'editCourseAttendanceFormWithReport'" lazy />
      <ManageExamQuestions v-if="$root.subContent.subContentComponent == 'ManageExamQuestions'" lazy
        :exam="$root.subContent.subContentData.exam"
        :programme_config_group_id="$root.subContent.subContentData.programme_config_group_id"
        :read-only="$root.subContent.subContentData.readOnly" />

      <!-- roleAcademicyearModal -->
      <b-modal id="roleAcademicyearModal" hide-header-close no-close-on-backdrop no-close-on-keyboard no-close-on-esc
        hide-footer>
        <!-- Custom Header -->
        <template #modal-header>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <h5 class="mb-0"><i class="fas fa-user-cog fa-2x mb-2 text-warning"
                style="font-size:16px !important; margin-right:6px!important; vertical-align:middle;"></i> User Role /
              Academic Year
            </h5>
            <i class="fas fa-times close-btn" @click="closeRoleAcademicyears"></i>
          </div>
        </template>
        <div class="p-3">
          <b-card class="shadow-sm mb-4 border-0 p-4">
            <!-- ROW 1 — SELECT ROLE -->
            <div class="row mb-4">
              <div class="col-12">
                <label class="form-label fw-bold">Select User Role</label>
                <b-form-select v-model="selectedInstituteRole" :options="institutionRolesOptions"
                  @change="changeInstituteRole" class="form-control-lg w-100 custom-select-lg" />
              </div>
            </div>

            <!-- ROW 2 — ACADEMIC YEAR -->
            <div class="row">
              <div class="col-12">
                <label class="form-label fw-bold">Academic Year</label>
                <b-form-select :options="$settingAcedemicYearsAndSemester" v-model="selectedYearSemester"
                  @change="setDefaultAcedemicYearSemester(true)" class="form-control-lg w-100 custom-select-lg" />
              </div>
            </div>
          </b-card>
        </div>
      </b-modal>

      <DashboardModal id="openAnalyticsModal" parent="Institute Dashboard" title="Analytics" icon="fas fa-chart-bar fa-2x mb-2 text-primary"
        @close="closeAnalytics">
        <!-- <DashboardCards lazy /> -->
         <Analytics lazy @openAttendancePreview="openAttendancePreview" @openCourseExitData="openCourseExitData" @openErrorsAndWarnings="openErrorsAndWarnings" />
      </DashboardModal>

      <DashboardModal id="attendancePreviewModal" parent="Institute Dashboard" title="Attendance Preview" icon="fas fa-calendar-check fa-2x mb-2 text-primary"
        @close="closeAttendancePreview">
        <AttendancePreview lazy />
      </DashboardModal>

      <DashboardModal id="courseExitDataModal" parent="Institute Dashboard" title="Course Exit Data" icon="fas fa-file-alt fa-2x mb-2 text-warning"
        @close="closeCourseExitData">
        <CourseExitData lazy />
      </DashboardModal>

      <DashboardModal id="errorsAndWarningsModal" parent="Institute Dashboard" title="Errors and Warnings" icon="fas fa-times-circle fa-2x mb-2 text-danger"
        @close="closeErrorsAndWarnings">
        <ErrorsAndWarnings lazy />
      </DashboardModal>

      <DashboardModal id="deletedResourcesModal" parent="Institute Dashboard" title="Deleted Resources" icon="fas fa-trash-restore fa-2x mb-2 text-danger"
        @close="closeDeletedResources">
        <DeletedResources lazy :getCustomNames="getCustomNames" />
      </DashboardModal>
<!-- 
      <DashboardModal id="openUsergroupModal" :title="getGroupLevelNames" icon="fas fa-sitemap fa-2x mb-2 text-info"
        @close="closeUsergroup">
        <Usergroup lazy :getCustomNames="getCustomNames" :selectedInstitute="selectedInstitute" />
      </DashboardModal> -->

      <!-- <DashboardModal id="usersListPendingModal" title="Staff, Student List" icon="fas fa-users fa-2x mb-2 text-primary"
        @close="closeUsersListPending">
        <users-list-pending lazy :selectedInstitute="selectedInstitute" @close="closeUsersListPending" />
      </DashboardModal> -->

      <DashboardModal id="attendanceModal" parent="Institute Dashboard" title="Attendance" icon="fas fa-user-check fa-2x mb-2 text-success"
        @close="closeAttendance">
        <StudentAttendence lazy :from_parent_login="false" />
      </DashboardModal>

      <DashboardModal id="activityModal" parent="Institute Dashboard" title="Activity" icon="fas fa-tasks fa-2x mb-2 text-purple"
        @close="closeActivity">
        <Exams lazy />
      </DashboardModal>

      <!-- <DashboardModal id="feeDueModal" parent="Institute Dashboard" title="Fee Payment" icon="fas fa-coins fa-2x mb-2 text-warning"
        @close="closeFeeDue">
        <FeeDue lazy />
      </DashboardModal> -->

      <DashboardModal id="classScheduleModal" parent="Institute Dashboard" title="Class Schedule" icon="fas fa-calendar-alt fa-2x mb-2 text-info"
        @close="closeClassSchedule">
        <new-schedule lazy/>
      </DashboardModal>

      <DashboardModal id="studentCourseModal" parent="Institute Dashboard" title="My Courses" icon="fas fa-clipboard-list fa-2x mb-2 text-primary"
        @close="closeStudentCourses">
        <StudentCourses lazy :editCourseComponents="editCourseComponents" :getCustomNames="getCustomNames" />
      </DashboardModal>

      <DashboardModal id="auditorsManagementModal" parent="Institute Dashboard" title="Audit Access Management"
        icon="fas fa-user-shield fa-2x mb-2 text-danger" @close="closeAuditorsManagement">
        <auditorsManagementDashboard lazy/>
      </DashboardModal>

      <DashboardModal id="admissionModal" parent="Institute Dashboard" title="General Forms"
        icon="fas fa-user-graduate fa-2x mb-2 text-purple" @close="closeAdmission">
        <AdmissionForms v-if="instituitionAdmin || admissionCoordinator || admissionFormSections.length > 0"
          :admissiondesk="!instituitionAdmin && !admissionCoordinator" :adminrole_admissiondesk="false" lazy />
      </DashboardModal>

      <!-- admission coordinators assigned as section approvers get the desk view separately from their Admission modal -->
      <DashboardModal id="admissionDeskModal" parent="Institute Dashboard" title="Admission Desk"
        icon="fas fa-user-graduate fa-2x mb-2 text-purple" @close="closeAdmissionDesk">
        <AdmissionForms v-if="admissionCoordinator && admissionFormSections.length > 0"
          :admissiondesk="true" :adminrole_admissiondesk="false" lazy />
      </DashboardModal>

      <!-- <DashboardModal id="feeManagementModal" title="Fee Management" icon="fas fa-coins fa-2x mb-2 text-warning"
        @close="closeFeeManagement">
        <feeManagementDashboard lazy />
      </DashboardModal> -->

      <DashboardModal id="approvalsModal" parent="Institute Dashboard" :title="applicationForm ? 'Application Forms' : 'Approvals'"
        icon="fas fa-check-circle fa-2x mb-2 text-orange" @close="closeApprovals">
        <Approvals lazy />
      </DashboardModal>

      <DashboardModal id="liveClassModal" parent="Institute Dashboard" title="Live Class" icon="fas fa-video fa-2x mb-2 text-danger"
        @close="closeLiveClass">
        <LiveClass lazy/>
      </DashboardModal>

      <DashboardModal id="applyLeaveModal" parent="Institute Dashboard" title="Apply For Leave" icon="fas fa-user-clock fa-2x mb-2 text-teal"
        @close="closeApplyLeave">
        <StudentLeave lazy/>
      </DashboardModal>

      <DashboardModal id="facultyApplyLeaveModal" parent="Institute Dashboard" title="Apply For Leave" icon="fas fa-user-clock fa-2x mb-2 text-teal"
        @close="closeFacultyApplyLeave">
        <FacultyApplyLeave lazy/>
      </DashboardModal>

      <DashboardModal id="courseCoverageMonitoringModal" parent="Institute Dashboard" title="Course Coverage Monitoring"
        icon="fas fa-chart-line fa-2x mb-2 text-success" @close="closeCourseCoverageMonitoring">
        <CourseCoverageMonitoring lazy />
      </DashboardModal>

      <DashboardModal id="requestLogModal" parent="Institute Dashboard" title="Request Log" icon="fas fa-history fa-2x mb-2 text-secondary"
        @close="closeRequestLog">
        <RequestLog lazy />
      </DashboardModal>

      <DashboardModal id="instituteConfigModal" parent="Institute Dashboard" title="Institute Config" icon="fas fa-cog fa-2x mb-2 text-dark"
        @close="closeInstituteConfig">
        <InstitutionSettings lazy :selectedInstitute="selectedInstitute" />
      </DashboardModal>

      <DashboardModal id="hostelModal" parent="Institute Dashboard" title="Hostel" icon="fas fa-bed fa-2x mb-2 text-primary" @close="closeHostel">
        <HostelDashboard lazy/>
      </DashboardModal>

      <DashboardModal id="eventModal" parent="Institute Dashboard" title="Events" icon="fas fa-calendar-check fa-2x mb-2 text-success"
        @close="closeEvent">
        <Event lazy/>
      </DashboardModal>

      <!-- <DashboardModal id="usersubgroupModal" :title="usersubgroupTitle" icon="fas fa-book-open fa-2x mb-2 text-indigo"
        @close="closeUsersubgroup">
        <Usersubgroup lazy :getCustomNames="getCustomNames" :selectedInstitute="selectedInstitute" />
      </DashboardModal> -->

      <!-- <DashboardModal id="instructorScheduleModal" title="Instructor Schedule"
        icon="fas fa-calendar-alt fa-2x mb-2 text-teal" @close="closeInstructorSchedule">
        <instructor-schedule lazy/>
      </DashboardModal> -->

      <!-- <DashboardModal id="surveyModal" title="Survey" icon="fas fa-poll fa-2x mb-2 text-pink" @close="closeSurvey">
        <ListingSurveys lazy />
      </DashboardModal> -->

      <!-- <DashboardModal id="universityExamModal" title="University Exam" icon="fas fa-university fa-2x mb-2 text-purple"
        @close="closeUniversityExam">
        <UniversityExamListing lazy />
      </DashboardModal> -->

      <DashboardModal id="courseGroupsModal" parent="Institute Dashboard" title="Courses &amp; Offerings"
        icon="fas fa-book fa-2x mb-2 text-success" @close="closeCourseGroups">
        <CourseGroupsPage lazy ref="courseGroupsPage" />
      </DashboardModal>

      <DashboardModal id="coeModal" parent="Institute Dashboard" :title="coeModalTitle"
        icon="fas fa-graduation-cap fa-2x mb-2 text-danger" @close="closeCoe">
        <CoeExamListing ref="coeExamListing" lazy @breadcrumb-change="coeModalTitle = $event" />
      </DashboardModal>

      <DashboardModal id="facultyCoeModal" parent="Institute Dashboard" :title="facultyCoeModalTitle"
        icon="fas fa-graduation-cap fa-2x mb-2 text-danger" @close="closeFacultyCoe">
        <FacultyCoeHome ref="facultyCoeHome" lazy @breadcrumb-change="facultyCoeModalTitle = $event" />
      </DashboardModal>

      <DashboardModal id="downloadReportModal" parent="Institute Dashboard" title="Download Report"
      icon="fas fa-file-download fa-2x mb-2 text-success"
      @close="closeDownloadReport">
        <DownloadReport lazy />
      </DashboardModal>

      <DashboardModal id="facultyLeaveRequestsModal" parent="Institute Dashboard" title="Staff Leave Requests"
        icon="fas fa-user-clock fa-2x mb-2 text-teal" @close="closeFacultyLeaveRequests">
        <FacultyLeaveRequests lazy />
      </DashboardModal>

      <DashboardModal id="facultyLeaveRecommendationsModal" parent="Institute Dashboard" title="Staff Leave Approval"
        icon="fas fa-user-check fa-2x mb-2 text-teal" @close="closeFacultyLeaveRecommendations">
        <FacultyLeaveRequests lazy hod />
      </DashboardModal>

      <b-modal id="facultyLeaveReportModal" title="Staff Leave Report" no-close-on-backdrop no-close-on-keyboard hide-footer centered size="lg" fullscreen>
        <FacultyLeaveReport />
      </b-modal>

      <DashboardModal id="staffLeaveSettingsModal" parent="Institute Dashboard" title="Staff Leave Settings"
        icon="fas fa-calendar-minus fa-2x mb-2 text-indigo" @close="closeStaffLeaveSettings">
        <FacultyLeaveSettings lazy />
      </DashboardModal>

      <DashboardModal id="facultyHoursModal" parent="Institute Dashboard" title="Faculty Hours"
        icon="fas fa-business-time fa-2x mb-2 text-orange" @close="closeFacultyHours">
        <FacultyHours lazy />
      </DashboardModal>

      <ManageSubgroupFeeStructure v-if="$root.subContent.subContentComponent == 'ManageSubgroupFeeStructure'" lazy
        :usergroup="$root.subContent.subContentData.usergroup"
        :financeCatagories="$root.subContent.subContentData.financeCatagories" />
      <ViewProfile v-if="$root.subContent.subContentComponent == 'ViewProfile'" lazy
        :groupInfo="$root.subContent.subContentData.groupInfo"
        :institutionUserId="$root.subContent.subContentData.institutionUserId"
        :sortByOrder="$root.subContent.subContentData.sortByOrder" />
      <!-- <b-modal id="applyForLeaveModal" no-close-on-backdrop no-close-on-keyboard hide-footer centered size="xl">
        <StudentLeave />
      </b-modal> -->
      <b-modal id="leaveRequestLogModal" no-close-on-backdrop no-close-on-keyboard hide-footer centered size="xl"
        fullscreen>
        <StudentLeaveRequestLog />
      </b-modal>
      <!-- <ExamQuestionPaperPreview v-if="$root.subContent.subContentComponent == 'ExamQuestionPaperPreview'" lazy 
      :exam="$root.subContent.subContentData.exam"
      :questionsAndGroupsAndSectionView="$root.subContent.subContentData.questionsAndGroupsAndSectionView"
        :groupObjects="$root.subContent.subContentData.groupObjects"  :questionObjects="$root.subContent.subContentData.questionObjects" :sectionObjects="$root.subContent.subContentData.sectionObjects" /> -->
    </b-collapse>
    <br />
  </div>
</template>

<script>
import axios from "axios";
import CoeExamListing from "@/components/templates/Dashboard/Institute/coe/CoeExamListing.vue";
import FacultyCoeHome from "@/components/templates/Dashboard/Institute/coe/FacultyCoeHome.vue";
import DownloadReport from "@/components/templates/Dashboard/DownloadReport.vue";
import FacultyLeaveRequests from "@/components/templates/Dashboard/Institute/settings/facultyLeaveComponents/FacultyLeaveRequests.vue";
import FacultyApplyLeave from "@/components/templates/Dashboard/Institute/settings/facultyLeaveComponents/FacultyApplyLeave.vue";
import FacultyLeaveReport from "@/components/templates/Dashboard/Institute/settings/facultyLeaveComponents/FacultyLeaveReport.vue";
import FacultyLeaveSettings from "@/components/templates/Dashboard/Institute/settings/FacultyLeaveSettings.vue";
import FacultyHours from "./facultyHours/FacultyHours.vue";
import CourseGroupsPage from "@/components/templates/Dashboard/Institute/courseGroups/CourseGroupsPage.vue";
import DashboardModal from "./DashboardModal.vue"
import Event from '@/components/templates/Dashboard/student/Event.vue';
import StudentLeave from "../student/Leave.vue";
// import FeeDue from "../student/FeeDue.vue"; // now rendered via routed page: /fee_payment
import StudentLeaveRequestLog from "../student/RequestLog.vue";
import editCourseAttendanceFormWithReport from "../attendence/editCourseAttendanceFormWithReport.vue";
import HostelDashboard from "../../../hostel/dashboard.vue";
import ExamEvaluation from "../examination/typeofexam/TypeOfExam.vue";
import ManageExamQuestions from "../examination/manageExamQuestions.vue";
import ViewProfile from './usergroups/usersubgroups/subgroup_users_edit/ViewProfile.vue';
// import ExamQuestionPaperPreview from "../examination/questionPaperPreview.vue";
//import UsersListPending from "../Institute/institution_users/UsersListPending.vue";
// import InstituteGroups from "./usergroups/InstituteGroups.vue";
// import CourseListing from "../Course/CourseListing.vue";
// import AttendenceMarking from "../attendence/AttendenceMarking.vue";
import NewAttendenceMarking from "../attendence/NewAttendenceMarking.vue";
// import MySchedule from "../timetable/MySchedule.vue";
import InstitutionMobileView from "../Institute/InstitutionMobileView.vue";
import MyCourses from "../Course/MyCourses.vue";
import ListingLiveClasses from "../live_class/ListingLiveClasses.vue";
// import InstitutionTimeTable from "../timetable/InstitutionTimeTable";
import NewSchedule from "../timetable/NewScheduler";
import InstructorSchedule from "../timetable/InstructorSchedule";
import ListingSurveys from "../survey/ListingSurveys.vue";
import Approvals from "../survey/survey_approvals/Approvals.vue";
import Exams from "../examination/Exams.vue";
// import userPermissions from "./userpermissions/userPermissions.vue";
//import ReportsOptions from "../reports/ReportsOptions.vue";
//import SetAcedemicYear from "./settings/SetAcedemicYear.vue";
import UniversityExamListing from "../university_exam/UniversityExamListing.vue";
import StudentAttendence from "../attendence/StudentAttendence.vue";
import InstituteInvite from "./invite/InstituitionInvite.vue";
//import EnrollUserToInstitute from "./settings/EnrollUserToInstitute.vue";
//import Usergroup from "../usergroup/MaingroupAndGroupTabs";
import Usersubgroup from "../usersubgroup/Usersubgroup";
import StudentCourses from "../student/MyCourses";
// import DashboardCards from "../../../dashboardCards/cards.vue";
import acl from "../../../../authorization/acl.js";
import auditorsManagementDashboard from "../../../auditor/dashboard.vue";
// import feeManagementDashboard from "../../../finance/dashboard.vue";
import ManageSubgroupFeeStructure from "../../../finance/manageSubgroupFeeStructure.vue";
import CourseCoverageMonitoring from "../Course/lesson_plan/CourseCoverageMonitoring.vue";
import RequestLog from "../attendence/RequestLogs.vue";
import AdmissionForms from './Admission/admissionForms.vue';
//import feeManagementDashboard from '../fee_management/dashboard.vue';
import InstitutionSettings from "./settings/InstitutionSettings.vue";
import Analytics from "../../../dashboardCards/Analytics.vue";
import AttendancePreview from "../../../dashboardCards/AttendancePreview.vue";
import CourseExitData from "../../../dashboardCards/CourseExitData.vue";
import ErrorsAndWarnings from "../../../dashboardCards/ErrorsAndWarnings.vue";
import DeletedResources from "./DeletedResources.vue";

export default {
  props: [
    "selectedInstitute",
    "instituteSubTab",
    "myIinstitutionEnrollmets",
    "filteredUniqueInstitutions",
    "defaultInstituteId",
    "instituitionAdmin",
    "isCoe",
    "isAccountsStaff",
    "sendInfo",
    "defaultInstitutionUserId",
    "canInviteUsers",
  ],

  async mounted() {
    this.fetchData = true;

    // PAINT UI FIRST
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    // RUN INITIAL LOADERS IN PARALLEL
    const promises = [
      this.handlePermissions(),
      this.getHodInviteSettings(),
      this.getFacultyLeaveViewerSetting(),
      this.getInstitutionRoles(),
      this.getDefaultAcedemicYear(),
      this.getDefaultAcedemicSemester()
    ];



    await Promise.all(promises);


    this.selectedYearSemester = [this.acedemic_year, this.semester];
    this.$root.default_academic_year[0] = this.selectedYearSemester[0];
    this.$root.default_academic_year[1] = this.selectedYearSemester[1];

    // back from an exam - reopen the activity list
    if (this.$route.query.open === "activity") {
      this.$router.replace({ query: {} });
      if (this.studentTab) this.openActivity();
    }

    // NON-BLOCKING: Check for new release
    if (!this.studentTab && this.$store.state.userRole != 'Student') {
      if (window.requestIdleCallback) {
        requestIdleCallback(() => this.checkForNewRelease());
      } else {
        setTimeout(() => this.checkForNewRelease(), 50);
      }
    }

    // NON-BLOCKING: Load admission forms later
    setTimeout(() => this.getAdmissionForms(), 100);

    // NON-BLOCKING: COE grid only for faculty assigned as QP faculty or evaluator
    if (!this.studentTab) this.getCoeAssignments();

    this.fetchData = false;
  },

  created() {
    // FAST PERMISSION CHECKS
    Promise.all([
      acl.isUserGranted("manageAuditors"),
      acl.isUserGranted("manageIqacStaff"),
    ]).then(([auditor, iqac]) => {
      this.auditorIqacComponantPermission = auditor || iqac;
    });

    // DELAYED WARNING
    setTimeout(() => this.checkAcademicYearWarning(), 4000);
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  components: {
    DashboardModal,
    //usersListPending: UsersListPending,
    // InstituteGroups: InstituteGroups,
    // CourseListing: CourseListing,
    // attendenceMarking: AttendenceMarking,
    // mySchedule: MySchedule,
    myCourses: MyCourses,
    instituteMobileView: InstitutionMobileView,
    liveClass: ListingLiveClasses,
    // institutionTimeTable: InstitutionTimeTable,
    NewSchedule,
    instructorSchedule: InstructorSchedule,
    ListingSurveys,
    Exams,
    // UserPermissions: userPermissions,
    Approvals,
    //ReportsOptions,
    //SetAcedemicYear,
    UniversityExamListing,
    StudentAttendence,
    InstituteInvite,
    //EnrollUserToInstitute,
    //Usergroup,
    Usersubgroup,
    StudentCourses,
    // DashboardCards,
    Analytics,
    AttendancePreview,
    CourseExitData,
    ErrorsAndWarnings,
    DeletedResources,
    ExamEvaluation,
    ManageExamQuestions,
    // ExamQuestionPaperPreview,
    HostelDashboard,
    NewAttendenceMarking,

    editCourseAttendanceFormWithReport,
    auditorsManagementDashboard,
    // feeManagementDashboard,
    ManageSubgroupFeeStructure,
    CourseCoverageMonitoring,
    //feeManagementDashboard,
    ViewProfile,
    RequestLog,
    StudentLeave,
    StudentLeaveRequestLog,
    AdmissionForms,
    InstitutionSettings,
    Event,
    DownloadReport,
    FacultyLeaveRequests,
    FacultyApplyLeave,
    FacultyLeaveReport,
    FacultyLeaveSettings,
    FacultyHours,
    CourseGroupsPage,
    CoeExamListing,
    FacultyCoeHome,
  },
  data() {
    return {
      yearsChart: {},
      selectedYearSemester: [],
      allow_hod_invite_faculty: false,
      admissionFormSections: [],
      admissionCoordinator: false,
      hrStaff: false,
      isLibrarian: false,
      currentToastId: null,
      tabIndex: 0,
      tabs: ["#markAttendence"],
      screenWidth: 0,
      mobileView: false,
      usersList: null,
      groupList: null,
      viewCoursesTab: null,
      myCourses: null,
      institutionTimetable: null,
      attendenceTab: null,
      studentTab: null,
      mySchedule: null,
      instructorSchedule: null,
      assessmentTab: null,
      liveClassTab: null,
      assignmentTab: null,
      reportsTab: null,
      surveyTab: null,
      viewSurveyApprovaTab: null,
      applicationForm: null,
      universityExam: null,
      coeModalTitle: "Controller of Examinations",
      facultyCoeModalTitle: "Controller of Examination",
      attendenceInfo: {},
      fetchData: false,
      viewType: "Assessment",
      institutionRolesOptions: [],
      selectedInstituteRole: null,
      editCourseComponents: false,
      componentHeight: "970px",
      inviteInstitutionUsers: false,
      mainGroupAdmin: null,
      hasCoeAssignment: false,
      userGroupAdmin: null,
      subgroupAdmin: null,
      tabColor: "black",
      surveyApprovals: [],
      userRolesObject: {},
      academicYearWarning: false,
      auditorIqacComponantPermission: false,
      acedemic_year: null,
      faculty_leave_requests_viewer_id: null,
      semester: null,
    };
  },

  computed: {
    studentRow1() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        this.studentTab && {
          icon: 'fa-clipboard-list',
          color: 'text-primary',
          text: 'My Courses',
          click: this.openStudentCourses
        },
        this.studentTab && this.institutionTimetable && {
          icon: 'fa-calendar-alt',
          color: 'text-info',
          text: 'Class Schedule',
          click: this.openClassSchedule
        },
        this.studentTab && {
          icon: 'fa-user-check',
          color: 'text-success',
          text: 'Attendance',
          click: this.openAttendance
        },
        this.assessmentTab && {
          icon: 'fa-tasks',
          color: 'text-purple',
          text: 'Activity',
          click: this.openActivity
        },
        this.surveyTab && {
          icon: 'fa-poll',
          color: 'text-pink',
          text: 'Survey',
          click: this.openSurvey
        },
        this.viewSurveyApprovaTab && {
          icon: 'fa-check-circle',
          color: 'text-orange',
          text: this.applicationForm ? 'Application Forms' : 'Approvals',
          click: this.openApprovals,
          extraPending: !this.applicationForm && this.$store.getters.getApprovalStatus.formsApprovals.status
        },
        this.surveyTab && {
          icon: 'fa-user-clock',
          color: 'text-teal',
          text: 'Apply for leave',
          click: this.openApplyLeave
        },
        this.studentTab && {
          icon: 'fa-coins',
          color: 'text-warning',
          text: 'Fee Payment',
          click: this.openFeeDue
        }
      ].filter(Boolean);
    },

    facultyButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        this.allow_hod_invite_faculty && this.mainGroupAdmin && {
          icon: 'fa-user-plus',
          color: 'text-primary',
          text: 'Invite Users',
          click: this.inviteUsers
        },
        (this.mainGroupAdmin || this.userGroupAdmin) && {
          icon: 'fa-sitemap',
          color: 'text-info',
          text: this.getGroupLevelNames,
          click: this.openUsergroupTab
        },
        this.instructorSchedule && {
          icon: 'fa-calendar-alt',
          color: 'text-teal',
          text: 'Instructor Schedule',
          click: this.openInstructorSchedule
        },
        this.instituitionAdmin && {
          icon: 'fa-user-graduate',
          color: 'text-purple',
          text: 'General Forms',
          click: this.openAdmission
        },
        !this.instituitionAdmin && this.admissionFormSections.length > 0 && {
          icon: 'fa-user-graduate',
          color: 'text-purple',
          text: 'Admission Desk',
          click: this.openAdmission
        },
        this.viewSurveyApprovaTab && {
          icon: 'fa-check-circle',
          color: 'text-orange',
          text: this.applicationForm ? 'Application Forms' : 'Approvals',
          click: this.openApprovals,
          extraPending: !this.applicationForm && this.$store.getters.getApprovalStatus.formsApprovals.counts
        },
        {
          icon: 'fa-chart-line',
          color: 'text-secondary',
          text: 'Course Coverage Monitoring',
          click: this.courseCoverageReport
        },
        this.$root.default_academic_year[0] != '0' && {
          icon: 'fa-clipboard-list',
          color: 'text-warning',
          text: 'Leave Request Log',
          click: this.openLeaveRequestLogModal
        },
        {
          icon: 'fa-chart-bar',
          color: 'text-primary',
          text: 'Analytics',
          click: this.openAnalytics
        },
        {
          icon: 'fa-history',
          color: 'text-secondary',
          text: 'Request Log',
          click: this.requestLog
        },
        {
          icon: 'fa-calendar-plus',
          color: 'text-teal',
          text: 'Apply for Leave',
          click: this.openFacultyApplyLeave
        },
        this.mainGroupAdmin && {
          icon: 'fa-user-check',
          color: 'text-teal',
          text: 'Staff Leave Approval',
          click: this.openFacultyLeaveRecommendations
        },
        this.hasCoeAssignment && {
          icon: 'fa-graduation-cap',
          color: 'text-danger',
          text: 'Controller of Examination',
          click: this.openFacultyCoe
        },
        this.faculty_leave_requests_viewer_id && this.faculty_leave_requests_viewer_id === Number(this.$store.getters.getDefaultInstituteUserId) && {
          icon: 'fa-user-clock',
          color: 'text-teal',
          text: 'Staff Leave Requests',
          click: this.openFacultyLeaveRequests
        },
        {
          icon: 'fa-file-download',
          color: 'text-success',
          text: 'Download Report',
          click: this.openDownloadReport
        },
      ].filter(Boolean);
    },

    coeButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        {
          icon: 'fa-book',
          color: 'text-success',
          text: 'Courses & Offerings',
          click: this.openCourseGroups
        },
        {
          icon: 'fa-graduation-cap',
          color: 'text-danger',
          text: 'Controller of Examinations',
          click: this.openCoe
        },
      ].filter(Boolean);
    },

    accountsButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        {
          icon: 'fa-coins',
          color: 'text-warning',
          text: 'Fee Management',
          click: this.feeManagement
        },
      ].filter(Boolean);
    },

    admissionCoordinatorButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        {
          icon: 'fa-user-graduate',
          color: 'text-purple',
          text: 'Admission',
          click: this.openAdmission
        },
        this.admissionFormSections.length > 0 && {
          icon: 'fa-user-graduate',
          color: 'text-purple',
          text: 'Admission Desk',
          click: this.openAdmissionDesk
        },
      ].filter(Boolean);
    },

    hrButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        {
          icon: 'fa-file-alt',
          color: 'text-teal',
          text: 'Faculty Leave Report',
          click: this.openFacultyLeaveReport
        },
        {
          icon: 'fa-calendar-minus',
          color: 'text-indigo',
          text: 'Staff Leave Settings',
          click: this.openStaffLeaveSettings
        },
        {
          icon: 'fa-business-time',
          color: 'text-orange',
          text: 'Faculty Hours',
          click: this.openFacultyHours
        },
      ];
    },

    librarianButtons() {
      return [
        {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
      ];
    },

    roleText() {
      return `
        Role : <small>${this.$store.state.userRole}</small><br>
        <small>${this.acedemic_year && this.acedemic_year.length === 7
          ? `${this.acedemic_year}-${this.semester}`
          : 'All'
        }</small>
      `
    },
    /* ================= ROW 1 ================= */
    adminRow1() {
      return [
        this.usersList && {
          icon: 'fa-user-cog',
          color: 'text-warning',
          text: this.roleText,
          click: this.openRoleAcademicyears
        },
        {
          icon: 'fa-user-plus',
          color: 'text-primary',
          text: 'Invite Users',
          click: this.inviteUsers
        },
        this.usersList && {
          icon: 'fa-users',
          color: 'text-indigo',
          text: 'Staff, Student List',
          click: this.openStaffStudentList
        },
        (this.mainGroupAdmin || this.userGroupAdmin) && {
          icon: 'fa-sitemap',
          color: 'text-info',
          text: this.getGroupLevelNames,
          click: this.openUsergroupTab
        },
        (this.mainGroupAdmin || this.userGroupAdmin || this.subgroupAdmin) && {
          icon: 'fa-book-open',
          color: 'text-indigo',
          text:
            (this.getCustomNames.userSubgroup.custom_name ??
              'Usersubgroup') + '/Courses',
          click: this.openUsersubgroup
        },
        this.instructorSchedule && {
          icon: 'fa-calendar-alt',
          color: 'text-teal',
          text: 'Instructor Schedule',
          click: this.openInstructorSchedule
        },
        this.universityExam && {
          icon: 'fa-university',
          color: 'text-purple',
          text: 'University Exam',
          click: this.openUniversityExam
        },
        this.surveyTab && {
          icon: 'fa-poll',
          color: 'text-pink',
          text: 'Survey',
          click: this.openSurvey
        }
      ].filter(Boolean)
    },

    /* ================= ROW 2 ================= */
    adminRow2() {
      return [
        this.auditorIqacComponantPermission && {
          icon: 'fa-user-shield',
          color: 'text-danger',
          text: 'Audit Access Management',
          click: this.openAuditAccess
        },
        this.instituitionAdmin && {
          icon: 'fa-book',
          color: 'text-success',
          text: 'Courses & Offerings',
          click: this.openCourseGroups
        },
        {
          icon: 'fa-user-graduate',
          color: 'text-purple',
          text: 'General Forms',
          click: this.openAdmission
        },
        this.instituitionAdmin && {
          icon: 'fa-coins',
          color: 'text-warning',
          text: 'Fee Management',
          click: this.feeManagement
        },
        this.usersList && {
          icon: 'fa-bed',
          color: 'text-primary',
          text: 'Hostel',
          click: this.openHostel
        },
        this.viewSurveyApprovaTab && {
          icon: 'fa-check-circle',
          color: 'text-orange',
          text: this.applicationForm ? 'Application Forms' : 'Approvals',
          click: this.openApprovals
        },
        this.usersList && {
          icon: 'fa-calendar-check',
          color: 'text-success',
          text: 'Events',
          click: this.openEvent
        },
      ].filter(Boolean)
    },

    /* ================= ROW 3 ================= */
    adminRow3() {
      return [
        {
          icon: 'fa-chart-bar',
          color: 'text-primary',
          text: 'Analytics',
          click: this.openAnalytics
        },
        {
          icon: 'fa-chart-line',
          color: 'text-secondary',
          text: 'Course Coverage Monitoring',
          click: this.courseCoverageReport
        },
        this.$root.default_academic_year[0] !== '0' && {
          icon: 'fa-clipboard-list',
          color: 'text-warning',
          text: 'Student Leave Approval',
          click: this.openLeaveRequestLogModal
        },
        this.faculty_leave_requests_viewer_id && this.faculty_leave_requests_viewer_id === Number(this.$store.getters.getDefaultInstituteUserId) && {
          icon: 'fa-user-clock',
          color: 'text-teal',
          text: 'Staff Leave Approval',
          click: this.openFacultyLeaveRequests
        },
        this.faculty_leave_requests_viewer_id && this.faculty_leave_requests_viewer_id === Number(this.$store.getters.getDefaultInstituteUserId) && {
          icon: 'fa-file-alt',
          color: 'text-teal',
          text: 'Staff Leave Report',
          click: this.openFacultyLeaveReport
        },
        {
          icon: 'fa-history',
          color: 'text-secondary',
          text: 'Request Log',
          click: this.requestLog
        },        
        (this.instituitionAdmin || this.isCoe) && {
          icon: 'fa-graduation-cap',
          color: 'text-danger',
          text: 'Controller of Examinations',
          click: this.openCoe
        },
        {
          icon: 'fa-trash-restore',
          color: 'text-danger',
          text: 'Deleted Resources',
          click: this.openDeletedResources
        },
        {
          icon: 'fa-cog',
          color: 'text-dark',
          text: 'Institute Config',
          click: this.openInstituteConfig
        },
        {
          icon: 'fa-file-download',
          color: 'text-success',
          text: 'Download Report',
          click: this.openDownloadReport
        },
      ].filter(Boolean)
    },
    customName() {
      return this.$store.getters.getCustomNamings;
    },
    loadInstitutes() {
      return this.$store.getters.getInstituteStatus;
    },
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
    getGroupLevelNames() {
      const main = this.getCustomNames.mainGroup.custom_name;
      const user = this.getCustomNames.userGroup.custom_name;

      if (main && !user) return `${main} / Usergroup`;
      if (!main && user) return `Maingroup / ${user}`;
      if (main && user) return `${main} / ${user}`;
      return "Maingroup / Usergroup";
    },
  },

  methods: {
    async getDefaultAcedemicYear() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/user/setting/default_academic_year";
      await this.$axios
        .get(url)
        .then((response) => {
          this.acedemic_year = `${response.data}`;
        })
        .catch((error) => {
          error;
        });
    },
    async getDefaultAcedemicSemester() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/user/setting/default_semester";
      await this.$axios
        .get(url)
        .then((response) => {
          this.semester = `${response.data}`;
        })
        .catch((error) => {
          error;
        });
    },
    async getHodInviteSettings() {
      const settingKey = "allow_hod_invite_faculty";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);

      await axios
        .get(url)
        .then((response) => {
          let setting = response.data;
          if (setting) {
            this.allow_hod_invite_faculty = !!setting; // convert to boolean
          } else {
            this.allow_hod_invite_faculty = false; // default unchecked
          }
        })
    },
    async getFacultyLeaveViewerSetting() {
      const url = this.$store.getters.getAPIKey.institutionSettings.replace("setting_key", "faculty_leave_requests_viewer_id");
      await axios.get(url)
        .then((response) => {
          this.faculty_leave_requests_viewer_id = response.data ? Number(response.data) : null;
        })
        .catch(() => {});
    },

    async getCoeAssignments() {
      const mainAPI = this.$store.getters.getAPIKey.mainAPI;
      const [qpSets, evaluations] = await Promise.all([
        axios.get(`${mainAPI}/faculty/qp-sets`).catch(() => null),
        axios.get(`${mainAPI}/faculty/evaluations`).catch(() => null)
      ]);
      const hasRows = (response) => !!(response && response.data && response.data.data && response.data.data.length);
      this.hasCoeAssignment = hasRows(qpSets) || hasRows(evaluations);
    },

    openLeaveRequestLogModal() {
      this.$bvModal.show("leaveRequestLogModal");
    },
    // openLeaveModal() {
    //   this.$bvModal.show("applyForLeaveModal");
    // },

    async getAdmissionForms() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms?is_admissiondesk=true`;
      const response = await this.$axios.get(url);
      this.admissionFormSections = response.data.sections ?? [];
    },

    openHelpTab() {
      const route = this.$router.resolve({
        name: "helpAndQuestions",
        params: { tab: "updates" },
      });
      window.open(route.href, "_blank");
    },

    async checkForNewRelease() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionuser/checknewrelease`;
        const response = await axios.get(url);
        if (response.data.isNewUpdateReleased) {
          const toast = this.$toast.success(this.generateReleaseNotificationContent(), {
            position: "bottom-right",
            duration: 20000,
          });
          this.currentToastId = toast.id;
        }
      } catch (error) {
        console.error(error);
      }
    },

    generateReleaseNotificationContent() {
      const container = document.createElement("div");
      container.style.textAlign = "center";
      container.style.width = "300px";
      container.style.margin = "0 auto";

      const title = document.createElement("p");
      title.style.fontSize = "18px";
      title.style.fontWeight = "bold";
      title.textContent = "Update Release Notification";
      container.appendChild(title);

      const body = document.createElement("p");
      body.innerHTML = `
      <div style="margin-top:10px; display:flex; justify-content:center; gap:10px;">
        <button style="background:#007BFF; color:white; border:none; padding:5px 15px; border-radius:5px" 
          onclick="window.vueInstance.openHelpTab()">View</button>
        <button style="background:#6c757d; color:white; border:none; padding:5px 15px; border-radius:5px" 
          onclick="window.vueInstance.dismissNotification(window.vueInstance.currentToastId)">View Later</button>
      </div>`;
      container.appendChild(body);

      window.vueInstance = this;
      return container.outerHTML;
    },

    dismissNotification(toastId) {
      if (toastId) {
        this.$toast.dismiss(toastId);
      }
    },

    // Multiple modal open/close actions
    feeManagement() { 
      // this.$bvModal.show("feeManagementModal"); 
      this.$router.push({
        path: `/feemanagement`
      });
    },
    // closeFeeManagement() { this.$bvModal.hide("feeManagementModal"); },

    openAnalytics() { this.$bvModal.show("openAnalyticsModal"); },
    closeAnalytics() { this.$bvModal.hide("openAnalyticsModal"); },

    openAttendancePreview() { this.$bvModal.show("attendancePreviewModal"); },
    closeAttendancePreview() { this.$bvModal.hide("attendancePreviewModal"); },

    openCourseExitData() { this.$bvModal.show("courseExitDataModal"); },
    closeCourseExitData() { this.$bvModal.hide("courseExitDataModal"); },

    openErrorsAndWarnings() { this.$bvModal.show("errorsAndWarningsModal"); },
    closeErrorsAndWarnings() { this.$bvModal.hide("errorsAndWarningsModal"); },

    openDeletedResources() { this.$bvModal.show("deletedResourcesModal"); },
    closeDeletedResources() { this.$bvModal.hide("deletedResourcesModal"); },

    openUsergroupTab() { 
      this.$router.push({
        path: `/usergroup`
      });
     
      // this.$bvModal.show("openUsergroupModal");
     
     },
    // closeUsergroup() { this.$bvModal.hide("openUsergroupModal"); },

    openStaffStudentList() {
      this.$router.push({
        path: `/staff_student_list`
      });
    },

    // closeUsersListPending() { this.$bvModal.hide("usersListPendingModal"); },

    openRoleAcademicyears() { this.$bvModal.show("roleAcademicyearModal"); },
    closeRoleAcademicyears() { this.$bvModal.hide("roleAcademicyearModal"); },

    openStudentCourses() { this.$bvModal.show("studentCourseModal"); },
    closeStudentCourses() { this.$bvModal.hide("studentCourseModal"); },

    openClassSchedule() { this.$bvModal.show("classScheduleModal"); },
    closeClassSchedule() { this.$bvModal.hide("classScheduleModal"); },

    openAttendance() { this.$bvModal.show("attendanceModal"); },
    closeAttendance() { this.$bvModal.hide("attendanceModal"); },

    openFeeDue() {
      this.$router.push({
        path: `/fee_payment`
      });
    },

    openActivity() { this.$bvModal.show("activityModal"); },
    closeActivity() { this.$bvModal.hide("activityModal"); },

    courseCoverageReport() { this.$bvModal.show("courseCoverageMonitoringModal"); },
    closeCourseCoverageMonitoring() { this.$bvModal.hide("courseCoverageMonitoringModal"); },

    openEvent() { this.$bvModal.show("eventModal"); },
    closeEvent() { this.$bvModal.hide("eventModal"); },

    openHostel() { this.$bvModal.show("hostelModal"); },
    closeHostel() { this.$bvModal.hide("hostelModal"); },

    openUsersubgroup() { 
      // this.$bvModal.show("usersubgroupModal"); 
      this.$router.push({
        path: `/usersubgroup`
      });
    },
    // closeUsersubgroup() { this.$bvModal.hide("usersubgroupModal"); },

    openInstructorSchedule() { 
      // this.$bvModal.show("instructorScheduleModal"); 
      this.$router.push({
        path: `/instructorschedule`
      });
    },
    // closeInstructorSchedule() { this.$bvModal.hide("instructorScheduleModal"); },

    openSurvey() { 
      // this.$bvModal.show("surveyModal"); 
      this.$router.push({
        path: `/survey`
      });
    },
    // closeSurvey() { this.$bvModal.hide("surveyModal"); },

    openUniversityExam() { 
      // this.$bvModal.show("universityExamModal"); 
      this.$router.push({
        path: `/universityexam`
      });
    },
    // closeUniversityExam() { this.$bvModal.hide("universityExamModal"); },

    openApprovals() { this.$bvModal.show("approvalsModal"); },
    closeApprovals() { this.$bvModal.hide("approvalsModal"); },

    openApplyLeave() { this.$bvModal.show("applyLeaveModal"); },
    closeApplyLeave() { this.$bvModal.hide("applyLeaveModal"); },

    openLiveClass() { this.$bvModal.show("liveClassModal"); },
    closeLiveClass() { this.$bvModal.hide("liveClassModal"); },

    openAdmission() { this.$bvModal.show("admissionModal"); },
    closeAdmission() { this.$bvModal.hide("admissionModal"); },
    openAdmissionDesk() { this.$bvModal.show("admissionDeskModal"); },
    closeAdmissionDesk() { this.$bvModal.hide("admissionDeskModal"); },

    openAuditAccess() { this.$bvModal.show("auditorsManagementModal"); },
    closeAuditorsManagement() { this.$bvModal.hide("auditorsManagementModal"); },

    requestLog() { this.$bvModal.show("requestLogModal"); },
    closeRequestLog() { this.$bvModal.hide("requestLogModal"); },

    openDownloadReport() { this.$bvModal.show("downloadReportModal"); },
    closeDownloadReport() { this.$bvModal.hide("downloadReportModal"); },

    openInstituteConfig() { this.$bvModal.show("instituteConfigModal"); },
    closeInstituteConfig() { this.$bvModal.hide("instituteConfigModal"); },

    openCourseGroups() { this.$bvModal.show("courseGroupsModal"); },
    closeCourseGroups() {
      if (this.$refs.courseGroupsPage && this.$refs.courseGroupsPage.goBack()) return;
      this.$bvModal.hide("courseGroupsModal");
    },

    openFacultyLeaveRequests() { this.$bvModal.show("facultyLeaveRequestsModal"); },
    closeFacultyLeaveRequests() { this.$bvModal.hide("facultyLeaveRequestsModal"); },

    openFacultyLeaveRecommendations() { this.$bvModal.show("facultyLeaveRecommendationsModal"); },
    closeFacultyLeaveRecommendations() { this.$bvModal.hide("facultyLeaveRecommendationsModal"); },

    openFacultyLeaveReport() { this.$bvModal.show("facultyLeaveReportModal"); },
    closeFacultyLeaveReport() { this.$bvModal.hide("facultyLeaveReportModal"); },

    openStaffLeaveSettings() { this.$bvModal.show("staffLeaveSettingsModal"); },
    closeStaffLeaveSettings() { this.$bvModal.hide("staffLeaveSettingsModal"); },

    openFacultyHours() { this.$bvModal.show("facultyHoursModal"); },
    closeFacultyHours() { this.$bvModal.hide("facultyHoursModal"); },

    openFacultyApplyLeave() { this.$bvModal.show("facultyApplyLeaveModal"); },
    closeFacultyApplyLeave() { this.$bvModal.hide("facultyApplyLeaveModal"); },

    openFacultyCoe() {
      this.facultyCoeModalTitle = "Controller of Examination";
      this.$bvModal.show("facultyCoeModal");
    },
    closeFacultyCoe() {
      if (this.$refs.facultyCoeHome && this.$refs.facultyCoeHome.goBack()) {
        return;
      }
      this.facultyCoeModalTitle = "Controller of Examination";
      this.$bvModal.hide("facultyCoeModal");
    },

    openCoe() { this.coeModalTitle = "Controller of Examinations"; this.$bvModal.show("coeModal"); },
    closeCoe() {
      if (this.$refs.coeExamListing && this.$refs.coeExamListing.goBack()) {
        return;
      }
      this.coeModalTitle = "Controller of Examinations";
      this.$bvModal.hide("coeModal");
    },

    checkAcademicYearWarning() {
      setTimeout(() => (this.academicYearWarning = true), 4000);
    },

    async handlePermissions() {
      this.usersList = await acl.isUserGranted("viewInstitutionUsers");
      this.groupList = await acl.isUserGranted("viewGroupsSubgroupsTab");
      this.viewCoursesTab = await acl.isUserGranted("viewCoursesTab");
      this.myCourses = await acl.isUserGranted("myCourses");
      this.institutionTimetable = await acl.isUserGranted("ViewInstitutionTimeTableTab");
      this.attendenceTab = await acl.isUserGranted("viewManageAttendanceTab");
      this.studentTab = await acl.isUserGranted("viewStudentTab");
      this.mySchedule = await acl.isUserGranted("mySchedule");
      this.instructorSchedule = await acl.isUserGranted("ViewInstructorTimeTableTab");
      this.assessmentTab = await acl.isUserGranted("viewAssessmentTab");
      this.liveClassTab = await acl.isUserGranted("viewLiveClassTab");
      this.assignmentTab = await acl.isUserGranted("viewAssignmentTab");
      this.reportsTab = await acl.isUserGranted("viewReportsTab");
      this.surveyTab = await acl.isUserGranted("viewSurveyTab");
      this.viewSurveyApprovaTab = await acl.isUserGranted("viewSurveyApprovalTab");
      this.applicationForm = await acl.isUserGranted("SurveyApprovalStudent");
      this.universityExam = await acl.isUserGranted("universityExam");

      this.mainGroupAdmin = await acl.isUserGranted("mainGroupAdmin");
      this.userGroupAdmin = await acl.isUserGranted("groupAdmin");
      this.subgroupAdmin = await acl.isUserGranted("subgroupAdmin");
      this.admissionCoordinator = await acl.isUserGranted("viewAdmissionForms");
      this.hrStaff = await acl.isUserGranted("viewFacultyLeaveReport");
      this.isLibrarian = await acl.isUserGranted("librarian");

      await this.getFormsForApproversStatus();
    },

    async setDefaultAcedemicYearSemester(refersh) {
      const yearUrl =
        this.$store.getters.getAPIKey.mainAPI +
        "/user/setting/default_academic_year";
      await this.$axios
        .post(yearUrl, { default_academic_year: this.selectedYearSemester[0] })
        .then((response) => {
          // window.location.reload();
          response;
        })
        .catch((error) => {
          error;
          return;
        });

      const semUrl =
        this.$store.getters.getAPIKey.mainAPI +
        "/user/setting/default_semester";
      await this.$axios
        .post(semUrl, { default_semester: this.selectedYearSemester[1] })
        .then((response) => {
          if (refersh) window.location.reload();
          response;
        })
        .catch((error) => {
          error;
        });
    },
    async getInstitutionRoles() {
      this.selectedInstituteRole = null;
      this.institutionRolesOptions = [
        { value: null, text: "Select Role", disabled: true },
      ];

      await this.myIinstitutionEnrollmets.forEach((institute) => {
        if (this.selectedInstitute.id !== institute.institution.id) return;

        const roleKey = institute.institution_role.name; // teacher / student / hod etc.
        const roleName =
          roleKey === "teacher"
            ? "Faculty"
            : roleKey === "admission_coordinator"
              ? "Admission Coordinator"
              : roleKey === "hr"
                ? "HR"
                : roleKey.charAt(0).toUpperCase() + roleKey.slice(1);


        this.$set(this.userRolesObject, institute.id, roleName);

        if (Number(this.defaultInstitutionUserId) === institute.id) {
          this.selectedInstituteRole = this.defaultInstitutionUserId;
          this.$store.state.userRole = this.userRolesObject[this.selectedInstituteRole];
        }

        this.institutionRolesOptions.push({
          value: institute.id,
          text:
            this.selectedInstituteRole === institute.id
              ? `User Role: ${roleName}`
              : roleName,
        });
      });
    },



    async getFormsForApproversStatus() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/onlineregistrations/appforapproval/status`;

      const response = await this.$axios.get(url);
      this.$store.state.formsApprovals.status =
        response.data >= 1 ? true : false;

      this.$store.state.formsApprovals.counts =
        response.data;
    },

    async inviteUsers() {
      this.inviteInstitutionUsers = true;
      await this.$refs.inviteUsers.prepareInviteUsers();
    },

    changeInstituteRole(value) {
      this.$emit("changeInstituteRole", value);
    },

    handleResize() {
      this.screenWidth = window.innerWidth;
    },

    async markAttendenceInfo(attendenceInfo) {
      const index = this.tabs.findIndex((t) => t === this.$route.hash);
      this.tabIndex = index;
      this.attendenceInfo = attendenceInfo;
      await this.$refs.attendenceMarking.fillAttendenceDate();
      this.$forceUpdate();
    },
  }

};
</script>

<style>
/* Scoped adjustment only for Attendance tab under staffListTab */
#staffListTab .attendenceTab>>>.tab-pane {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Optional: reduce container gap slightly */
#staffListTab .tab-content {
  margin-top: 0px !important;
  /* instead of 10px in existing style */
}

.approval-btn .blink-dot {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  animation: blink 1s infinite;
}

.approval-btn:hover .blink-dot {
  opacity: 1;
}

@keyframes fadeBlink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.35;
  }

  100% {
    opacity: 1;
  }
}

#instituteTabs .approvalStatus i {
  font-size: 10px !important;
}

#instiConfig button {
  color: #5bc0de;
  display: flex;
  justify-content: center;
}

#instiConfig button:hover {
  background-color: #5bc0de !important;
  color: #ffffff;
}

#instituteTabs .nav-tabs {
  border-bottom: none !important;
}

#staffListTab .tab-content {
  border: 8px solid #EAF8F2;
  border-radius: 5px;
  background-color: #ffffff;
  margin-top: 10px;
}

.groupName .list-group-item,
.groupAdminName .list-group-item,
.hideSubgroups .list-group-item {
  border-style: none;
}

#staffListTab__BV_tab_container_ {
  min-height: 70vh;

  padding: 10px;
}

#instituteTabs ul {
  border-radius: none;
}

#instituteTabs ul li {
  border: 3px solid #EAF8F2;
}

#instituteTabs ul li a {
  font-size: 12px !important;
  width: 175px;
  text-align: center;
}

#instituteTabs .nav-tabs .nav-link {
  background-color: #1ea2ed;
  color: #ffffff;
}

#instituteTabs .nav-tabs #admin___BV_tab_button__ {
  background-color: #288745;
  color: #ffffff;
}

#instituteTabs .nav-tabs #admin___BV_tab_button__.active {
  background-color: white !important;
  color: #288745 !important;
}

#instituteTabs .nav-tabs .nav-link.active {
  background-color: white;
  color: #077bff;
}

#instituteTabs .nav-tabs #admission___BV_tab_button__ {
  background-color: orange;
  color: #ffffff;
}

#instituteTabs .nav-tabs #admission___BV_tab_button__.active {
  background-color: white !important;
  color: orange !important;
}

#courseFeatures .nav-tabs .nav-link.active {
  background-color: #077bff;
  color: #ffffff;
}

.dashboard-actions {
  display: flex;
  flex-wrap: wrap;
  /* Allow wrapping */
  justify-content: center;
  /* Center all buttons */
  gap: 14px;
  /* Consistent spacing */
  background: #f8f9fa;
  padding: 20px 15px;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.dashboard-btn-text {
  display: inline-block;
  height: 40px;
  /* adjusts based on how many lines you want */
  line-height: 18px;
  /* keeps lines evenly spaced */
  text-align: center;
}

/* Each card same width */
.action-card-btn {
  width: 110px;
  /* Perfect dashboard width */
  height: 110px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: 0.25s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.action-card-btn:hover {
  transform: translateY(-3px);
  border-color: #0d6efd;
  background: #f8fbff;
  box-shadow: 0 6px 12px rgba(13, 110, 253, 0.15);
}

/* Icon */
.action-card-btn i {
  font-size: 1.6rem;
  margin-bottom: 8px;
}

/* Text */
.action-card-btn span {
  font-size: 0.83rem;
  font-weight: 600;
  color: #333;
}


.action-card-btn:hover {
  transform: translateY(-3px);
  border-color: #0d6efd;
  box-shadow: 0 6px 12px rgba(13, 110, 253, 0.15);
  background: #f8fbff;
}

.action-card-btn i {
  font-size: 1.6rem;
  margin-bottom: 8px;
  transition: transform 0.3s ease;
}

.action-card-btn:hover i {
  transform: scale(1.15);
}

.action-card-btn span {
  display: block;
  font-size: 0.83rem;
  font-weight: 600;
  color: #333;
}

.action-card-btn:hover span {
  color: #0d6efd;
}

/* Icon colors */
.text-primary {
  color: #007bff !important;
}

.text-warning {
  color: #ffc107 !important;
}

.text-success {
  color: #198754 !important;
}

.text-secondary {
  color: #6c757d !important;
}

.text-dark {
  color: #212529 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-purple {
  color: #6f42c1 !important;
}

.text-orange {
  color: #fd7e14 !important;
}

.text-info {
  color: #17a2b8 !important;
}

.text-teal {
  color: #20c997 !important;
}

.text-pink {
  color: #e83e8c !important;
}

.text-indigo {
  color: #6610f2 !important;
}

/* Responsive */
@media (max-width: 1200px) {
  .action-card-btn {
    flex: 0 0 calc(9% - 6px);
  }
}

@media (max-width: 992px) {
  .dashboard-actions {
    flex-wrap: wrap;
    justify-content: center;
  }

  .action-card-btn {
    flex: 0 0 22%;
  }
}

@media (max-width: 768px) {
  .action-card-btn {
    flex: 0 0 30%;
  }
}

@media (max-width: 576px) {
  .action-card-btn {
    flex: 0 0 45%;
  }
}

.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100vh;
  width: 100vw;
}

.usersListPendingFull .modal-body {
  overflow-y: auto;
  height: calc(100vh - 60px);
  /* header height */
}

.close-btn {
  cursor: pointer;
  background: #dc3545;
  /* Danger red */
  color: #fff;
  /* White icon */
  font-size: 10px;
  /* Smaller icon */
  width: 24px;
  /* Slightly smaller square */
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  /* Slight rounding */
}

.close-btn:hover {
  background: #c82333;
  /* Darker danger */
}


@keyframes pulse-light {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }

  50% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

@keyframes pulseScale {
  0% {
    transform: translateX(-50%) scale(1);
  }

  50% {
    transform: translateX(-50%) scale(1.15);
  }

  100% {
    transform: translateX(-50%) scale(1);
  }
}
</style>